import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const QuestionDecisionApi = createAsyncThunk(
  'QuestionDecisionApi',
  async (questionDecisionPayload, { dispatch }) => {
    dispatch({ type: 'QuestionDecisionApi/pending', payload: {} });
    const {
      Authorization,
      customerRefNum,
      currentBlock,
      custJourneyAns,
      customerId,
      confirmSoftRejectionFlag,
    } = questionDecisionPayload;
    debug('LOOK', 'QuestionDecision from postpan');
    debug('LOOK', `questionDecisionPayload:`, questionDecisionPayload);
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerJourney/questiondecision',
      payload: {
        customerRefNum,
        currentBlock,
        appId: APP_ID,
        appVersion: APP_VERSION,
        custJourneyAns,
        confirmSoftRejectionFlag,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const QuestionDecisionRes = res;
        dispatch({
          type: 'QuestionDecisionApi/fulfilled',
          payload: QuestionDecisionRes,
        });
      },
      errorFn: (err) => {
        console.log('err from question decision api', err);
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'QuestionDecisionApi/rejected', payload: err });
      },
    });
  }
);

export const QuestionDecisionApi_extrareducer = {
  [QuestionDecisionApi.pending]: (state, action) => {
    state.questionDecisionApiState.isLoading = true;
  },
  [QuestionDecisionApi.fulfilled]: (state, action) => {
    state.questionDecisionApiState.isLoading = false;
    state.questionDecisionApiState.isSuccess = true;
    state.questionDecisionApiState.isError = false;
    state.questionDecisionApiState.response = action.payload;
  },
  [QuestionDecisionApi.rejected]: (state, action) => {
    state.questionDecisionApiState.isLoading = false;
    state.questionDecisionApiState.isSuccess = false;
    state.questionDecisionApiState.isError = true;
    state.questionDecisionApiState.response = action.payload;
  },
};
